export function OutlineInventarioIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0063 3H9.99829C8.89547 3 8.00146 3.89401 8.00146 4.99683V9.00488C8.00146 10.1077 8.89547 11.0017 9.99829 11.0017H14.0063C15.1092 11.0017 16.0032 10.1077 16.0032 9.00488V4.99683C16.0032 3.89401 15.1092 3 14.0063 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M12 3V6.42724" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path
        d="M10.0032 11.002H5.99512C4.8923 11.002 3.99829 11.896 3.99829 12.9988V17.0068C3.99829 18.1096 4.8923 19.0037 5.99512 19.0037H10.0032C11.106 19.0037 12 18.1096 12 17.0068V12.9988C12 11.896 11.106 11.002 10.0032 11.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.00171 11.002V14.4292"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.0049 11.002H13.9968C12.894 11.002 12 11.896 12 12.9988V17.0068C12 18.1096 12.894 19.0037 13.9968 19.0037H18.0049C19.1077 19.0037 20.0017 18.1096 20.0017 17.0068V12.9988C20.0017 11.896 19.1077 11.002 18.0049 11.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9985 11.002V14.4292"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3 18.998H21.0002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.00171 20.9997V18.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.9983 20.9997V18.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
